import React from 'react';
import { useAppStore } from '../../stores/appStore';
import { useAppStoreActions } from '../../stores/actions/appActions';

// Store-based hooks for direct store access
const useAppStoreData = () => {
  const currentLanguage = useAppStore((state) => state.currentLanguage);
  const currentMuiLanguage = useAppStore((state) => state.currentMuiLanguage);
  const currentListPanel = useAppStore((state) => state.currentListPanel);
  const currentViewPanel = useAppStore((state) => state.currentViewPanel);
  const messages = useAppStore((state) => state.messages);
  const status = useAppStore((state) => state.status);
  const isSyncing = useAppStore((state) => state.isSyncing);
  const isSidebarOpen = useAppStore((state) => state.isSidebarOpen);
  const currentView = useAppStore((state) => state.currentView);
  const theme = useAppStore((state) => state.theme);
  const isLoading = useAppStore((state) => state.isLoading);
  const error = useAppStore((state) => state.error);
  
  return {
    currentLanguage,
    currentMuiLanguage,
    currentListPanel,
    currentViewPanel,
    messages,
    status,
    isSyncing,
    isSidebarOpen,
    currentView,
    theme,
    isLoading,
    error
  };
};

/**
 * 应用管理Hook - 提供应用级别的状态和操作
 */
export const useAppManager = () => {
  // 获取store状态和操作
  const { currentLanguage, currentListPanel, currentViewPanel, messages, status, isSyncing, isSidebarOpen, currentView, theme, isLoading, error } = useAppStoreData();
  const storeActions = useAppStoreActions();
  
  // 语言相关状态
  const isChinese = React.useMemo(() => currentLanguage === 'zh', [currentLanguage]);
  const isEnglish = React.useMemo(() => currentLanguage === 'en', [currentLanguage]);
  
  return {
    // 应用状态
    currentLanguage,
    currentListPanel,
    currentViewPanel,
    messages,
    status,
    isSyncing,
    isSidebarOpen,
    currentView,
    theme,
    isLoading,
    error,
    
    // 应用操作 - 使用storeActions
    ...storeActions,
    
    // 语言状态
    isChinese,
    isEnglish,
    
    // 注意：应用启动时的数据预加载由 useInitialDataManager（React Query 预载 hooks）负责，
    // 各页面已直接调用 useInitialDataManager()，这里不再提供空实现的 initialDataFetch（05-5.14）
  };
};